import { Box, Flex, Image, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import circleAlertIcon from "#/assets/circle-alert-small.svg"
import externalLinkArrow from "#/assets/external-link-arrow.svg"
import { selectActiveToken, useDappSelector } from "#/redux-state"
import { links } from "#/shared/constants"
import { isStablecoin } from "#/shared/utils"

export default function DepositWarning() {
  const activeToken = useDappSelector(selectActiveToken)

  if (!isStablecoin(activeToken)) return null

  return (
    <Box
      bg="#EE04C8"
      color="primary.white.100"
      borderRadius="8px"
      p="12px"
      mb="32px"
    >
      <Flex gap="12px">
        <Image
          src={circleAlertIcon}
          width="24px"
          height="24px"
          filter="brightness(0) invert(1)"
          mt="2px"
        />
        <Text variant="body">
          Some stablecoins deposited in Mezo are eligible for staking and can
          earn you mats incentives, subject to the Mezo{" "}
          <Link to={links.TERMS_OF_USE} target="_blank">
            <Flex display="inline-flex" gap="4px" alignItems="center">
              <Text as="span" textDecoration="underline">
                Terms of Use
              </Text>
              <Image
                display="inline"
                src={externalLinkArrow}
                width="16px"
                height="16px"
                filter="brightness(0) invert(1)"
              />
            </Flex>
          </Link>
        </Text>
      </Flex>
    </Box>
  )
}
